module.exports = __webpack_public_path__ + "static/media/Construction_Bridge_Loan.f3e5b666.png";